import { useQuery } from 'react-query'
import AIGenerationService from 'src/services/ai-generation.service'

import { QUERY_KEYS } from 'src/constants'

const useGetAvailableModels = () => {
  return useQuery([QUERY_KEYS.AVAIABLE_MODELS], () => AIGenerationService.getAvailableModels(), {
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}

export { useGetAvailableModels }
